export const paperStyles = { margin: 0 }
